<div class="padding bg-light-grey">
	<div class="flex center">
		<span class="flex center primary hover margin-right" [routerLink]="['/order-list']">
			<i class="fa-solid fa-arrow-left margin-right-small"></i>
			Back
		</span>

		Orders
		<i class="fa-solid fa-angle-right padding-right-small padding-left-small grey"></i>
		Order info
	</div>
</div>

<!-- Button section -->
<div class="selector-container">
	@for(tab of tabs; track tab){
	<div class="tab-selector" [ngClass]="{'active': tab.url === activeSubRoute}">
		{{tab.title}}
	</div>
	}
</div>

<div class="padding page-layout">
	<router-outlet (activate)="onOutletActivate($event)"/>
</div>
